import {addLocaleData} from "react-intl";
import __intlEN from "react-intl/locale-data/en";
import __intlFI from "react-intl/locale-data/fi";
import flatten from "flat";

// Get our translations files
import localeEN from "../lang/en.json";
import localeFI from "../lang/fi.json";

// Load "en" and "fi" utils
addLocaleData(__intlEN);
addLocaleData(__intlFI);

const locales = ['en', 'fi'];
const defaultLocale = 'fi';

const messages = {
  en: flatten(localeEN),
  fi: flatten(localeFI),
};

export function getLocale(url) {
  // Get the "en" from the url "http://domain.tld/en"
  const firstURIlevel = url.replace(/^\//, "").split("/")[0]

  // If there is not the locale in the url, we take the default locale
  return firstURIlevel && locales.indexOf(firstURIlevel) > -1
    ? firstURIlevel
    : defaultLocale
}

export function getIntl(locale) {
  // We will inject this into IntlProvider
  return {
    locale: locale,
    messages: messages[locale],
    defaultLocale: defaultLocale,
  }
}



// WEBPACK FOOTER //
// ./src/utils/intl.js